import * as React from 'react';
import { Route } from 'react-router-dom';

export interface ITabsProps {
  tabsWrapperClassName?: string;
  activeTabClassName?: string;
  tabClassName?: string;
  tabHeaderClassName?: string;
  tabFooterClassName?: string;
  tabBodyClassName?: string;
  tabsContainerClassName?: string;
  currentTab?: number;
  onTabChanged?(tabNumber: number): void;
  renderToHeader?(): JSX.Element;
  renderToBody?(): JSX.Element;
  renderToAside?(): JSX.Element;
}

export interface ITabsState {
  currentTab: number;
}

export default class Tabs extends React.Component<ITabsProps, ITabsState> {
  constructor(props: ITabsProps) {
    super(props);
    this.state = {
      currentTab: props.currentTab ? props.currentTab : 0,
    };
  }

  componentWillReceiveProps(props: ITabsProps) {
    if (props.currentTab !== this.state.currentTab && this.props.onTabChanged) {
      if (props.currentTab != undefined) {
        this.setState({ currentTab: props.currentTab });
      }
    }
  }

  tabChanged(tabNumber: number) {
    this.setState({ currentTab: tabNumber });

    if (this.props.onTabChanged) {
      this.props.onTabChanged(tabNumber);
    }
  }

  render() {

    const currentTab = this.state.currentTab;
    const children = ((this.props.children || []) as any);

    return (
      <div className={this.props.tabsWrapperClassName}>
        <div className={this.props.tabHeaderClassName}>
          <div className={this.props.tabsContainerClassName ? this.props.tabsContainerClassName : ''}>
            {Array.isArray(children) ?
              children.map((child, i) => {
                if (child && !child.props) return null;
                const active = (i === currentTab);
                return (
                  child && <Route key={i}
                    render={({ history }) => {
                      return (
                        <button
                          disabled={child.props.disabled}
                          key={i}
                          className={`${this.props.tabClassName} ${active ? this.props.activeTabClassName : ''}
                            ${child.props.className ? child.props.className : ''}`}
                          onClick={() => child.props.onClick ?
                            child.props.onClick(history) : this.tabChanged(i)
                          }>
                          {child.props.title}
                        </button>
                      );
                    }}
                  />
                );
              }) :
              <button
                className={this.props.activeTabClassName || ''}
                onClick={() => this.setState({ currentTab: 0 })}>
                {children.props.title}
              </button>
            }
          </div>
          {this.props.renderToAside ? this.props.renderToAside() : null}
          {this.props.renderToHeader ? this.props.renderToHeader() : null}
        </div>
        <div className={this.props.tabBodyClassName || ''}>
          {this.props.renderToBody ? this.props.renderToBody() : null}
          {children[currentTab]}
        </div>
      </div >
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Tabs/Tabs.tsx